import React from 'react';
import { connect } from 'react-redux';
import { ExternalScripts } from 'mm-ui-components';
import { getExternalScripts } from '../../store/config/config.selectors';
import { ExternalScripts as ExternalScriptsType } from '../../store/config/config.reducer';
import { AppState } from '../../store/initialStateRegistration';

interface HeadScriptsProps {
  scripts: ExternalScriptsType
}

const mapStateToProps: (state: AppState) => HeadScriptsProps = (state: AppState) => ({
  scripts: getExternalScripts(state),
});

export const HeadScriptsComponent: React.FunctionComponent<HeadScriptsProps> = ({ scripts }) => {
  return <ExternalScripts scripts={scripts} />;
};

export const HeadScripts = connect(mapStateToProps)(HeadScriptsComponent);
